import { Component, OnInit } from '@angular/core';

import { AppService }  from '../../services/app.service';
import { ApiConnectionService }  from '../../services/core/api-connection.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

import { DomSanitizer } from '@angular/platform-browser';
import { ConfigService } from 'src/app/services/core/config.service';


@Component({
  selector: 'app-lesson-overview',
  templateUrl: './lesson-overview.component.html',
  styleUrls: ['./lesson-overview.component.scss']
})
export class LessonOverviewComponent implements OnInit {
	chapter : any = {}; 
	name = '';

	lessons : any = [];
	choiceAssignments : any = [];

	choiceAssignmentTitle = '';

	constructor(
	  	public appService: AppService,
  		public dom: DomSanitizer,
		private route: ActivatedRoute,
	  	public api: ApiConnectionService,
		private location: Location,
		private config: ConfigService,
	  	private ngxLoader: NgxUiLoaderService
  	) {
	  	let self = this;

		self.appService.setDefaultAuthor();
		self.appService.setPageTitle('');
		this.appService.setPageDescription('');

		self.choiceAssignmentTitle = config.get('choice_assignments_title');

		this.appService.setShowCheckRequestAlert();
  	}

  	ngOnInit(): void {
	  	// this.appService.navActive();
		let self = this;

		let path = this.location.path(); 
			path = path.replace('/','');
		let slug = path; 

		if (this.route.snapshot.paramMap.get('id'))
		{
			slug = this.route.snapshot.paramMap.get('id');
		}

	    this.ngxLoader.start();
		  this.api.read('chapters/slug/'+slug+'').then((response) => {
			self.name = response['name'];
			self.appService.setPageTitle(response['name']);
			self.chapter = response;

			for (let key in self.chapter['lessons'])
			{
				if (self.chapter['lessons'][key]['type'] === 'CHOICE_ASSIGNMENT')
				{
					self.choiceAssignments.push(self.chapter['lessons'][key]);
				}
				else if (self.chapter['lessons'][key]['type'] === 'LESSON')
				{
					self.lessons.push(self.chapter['lessons'][key]);
				}
			}

			self.ngxLoader.stop();
		});
  	}
	  
	text (lesson) {
		return this.dom.bypassSecurityTrustHtml(lesson);
	}
}
